module.exports = __webpack_public_path__ + "static/fipcballmouse2-72d51837f1d8cd35948796c9bf79bafb.jpeg";